import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion, faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  useGetResourceDocMutation,
  useUpdateDocumentMutation,
  useRemoveDocumentMutation,
  useMoveDocumentMutation,
  useGetHtmlContentMutation,
  useUpdateAssignmentLessonMutation
} from '../../../../features/authentication/assignmentApislice';
import {
  useGetSetByIdMutation
} from '../../../../features/authentication/setApiSlice';
import { faEdit, faTrashAlt, faSave, faTable, faXmark, faEye, faBars } from '@fortawesome/free-solid-svg-icons';
import CustomToast from '../../../../components/Toast';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';
import QuestionPreviewTypes from '../../../../enums/questionPreviewTypes';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import 'react-quill/dist/quill.snow.css';
import AddNewResource from './AddNewResource';
import VideoModal from './VideoModal';
import DocumentModal from './DocumentModal';
import AudioModal from './AudioModal';
import ImageModal from './ImageModal';
import LessonModal from './LessonModal';
import {
  useLessonExistMutation
} from '../../../../features/authentication/setApiSlice';
import castleLogo from '../../../../assets/images/assignedVia_1.png';
import Skeleton from 'react-loading-skeleton';

const AttachResources = (props) => {
  const [castleResourceDetails, setCastleResourceDetails] = React.useState(false);
  const [videoModal, setVideoModal] = React.useState(false);
  const [videoUrl, setVideoUrl] = React.useState('');
  const [audioUrl, setAudioUrl] = React.useState('');
  const [imageUrl, setImageUrl] = React.useState('');
  const [documentModal, setDocumentModal] = React.useState(false);
  const [audioModal, setAudioModal] = React.useState(false);
  const [imageModal, setImageModal] = React.useState(false);
  const [getResourceDoc] = useGetResourceDocMutation();
  const [documentText, setDocumentText] = React.useState('');
  const [isEditDocument, setIsEditDocument] = React.useState(false);
  const [castleResources, setCastleResources] = React.useState([]);
  const [displayText, setDisplayText] = React.useState('');
  const [questionIds, setQuestionIds] = React.useState('');
  const [updateDocument] = useUpdateDocumentMutation();
  const [selectedRow, setSelectedRow] = React.useState(null);
  const [removeDocument] = useRemoveDocumentMutation();
  const [openConfirmModal, setOpenConfirmModal] = React.useState(false);
  const [documentId, setDocumentId] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [moveDocument] = useMoveDocumentMutation();
  const [assignmentResource, setAssignmentResource] = React.useState([]);
  const [questionResource, setQuestionResource] = React.useState([]);
  const [isMouseOver, setIsMouseOver] = React.useState(false);
  const [deletedPosition, setDeletedPosition] = React.useState(null);
  const [openAttachResource, setOpenAttachResource] = React.useState(false);
  const [getDocumentSetById] = useGetSetByIdMutation();
  const [lessonInfo, setLessonInfo] = React.useState([]);
  const [getHtmlContent] = useGetHtmlContentMutation();
  const [updateAssignmentLesson] = useUpdateAssignmentLessonMutation();
  const [openLessonModal, setOpenLessonModal] = React.useState(false);
  const [lessonText, setLessonText] = React.useState('');
  const [openLessonDeleteConfirmModal, setOpenLessonDeleteConfirmModal] = React.useState(false);
  const [lessonExist] = useLessonExistMutation();
  const [isLessonAvailable, setIsLessonAvailable] = React.useState(false);

  const resourceViewHandlerFromUrl = async (value) => {
    let filetype = value.split('.').pop();

    switch (filetype) {
    case 'mp3':
      setAudioModal(true);
      setAudioUrl(value);
      break;
    case 'mp4':
      setVideoModal(true);
      setVideoUrl(value);
      break;
    case 'jpg':
    case 'gif':
    case 'bmp':
    case 'png':
      setImageModal(true);
      setImageUrl(value);
      break;
    default:
      // Handle other file types or no match
      console.log('File Not Supported!');
      break;
    }
  };

  const resourceViewHandler = async (resourceType, resourceId, resourceUrl) => {
    setDocumentText('');
    let link;
    switch (resourceType) {
    case 'Video':
      setVideoModal(true);
      setVideoUrl(resourceUrl);
      break;
    case 'Document':
      try {
        const option = { documentId: resourceId };
        setDocumentModal(true);
        const response = await getResourceDoc(option).unwrap();
        setDocumentText(response.resourceText);
      } catch (error) {
        console.error(error);
      }
      break;
    case 'Audio':
      setAudioModal(true);
      setAudioUrl(resourceUrl);
      break;
    case 'Link':
    case 'PDF':
    case 'MS Word':
    case 'Power Point':
      link = document.createElement('a');
      link.href = resourceUrl;
      link.target = '_blank';
      link.click();
      break;
    case 'Lesson':
      await htmlContentHandler(resourceUrl);
      setOpenLessonModal(true);
      break;
    default:
      console.warn('Unknown resource type: ', resourceType);
    }
  };

  React.useEffect(() => {
    if (castleResourceDetails) {
      if (props.prefetchedData) {
        populateResources(props.prefetchedData);
      } else {
        props.fetchCastleResources();
      }
      getLesson(props.assignmentDetails?.lessonId);
    }
  }, [castleResourceDetails]);
  
  React.useEffect(() => {
    if (props.prefetchedData) {
      populateResources(props.prefetchedData);
    }
  }, [props.prefetchedData]);

  const populateResources = (data) => {
    setCastleResources(data);
    setAssignmentResource(data.filter(item => item.isAssignmentDocument === true));
    setQuestionResource(data.filter(item => item.isAssignmentDocument === false));
    setIsLoading(false);
    requestAnimationFrame(() => props.onLoadComplete?.());
  };

  const validateDisplayText = () => {
    if (displayText.trim().length === 0) {
      CustomToast('Display text cannot be empty', 'warning');
      return false;
    } else if (
      displayText.includes('\\') ||
      displayText.includes('/') ||
      displayText.includes('<') ||
      displayText.includes('>')) {
      CustomToast('Input cannot contain "\\" or "<" symbols', 'warning');
      return false;
    } else
      return true;
  };

  const validateQuestionIds = () => {
    let list = questionIds.split(',');
    let dashList = list.filter(value => value.includes('-'));
    let invalidInput = false;
    let dashInvalidInput = false;

    dashList.forEach(element => {
      let hyphenPosition = element.indexOf('-');
      let startValue = parseInt(element.substring(0, hyphenPosition), 10);
      let endValue = parseInt(element.substring(hyphenPosition + 1), 10);
      let nextChar = element.charAt(hyphenPosition + 1);

      if (isNaN(parseInt(nextChar, 10))) {
        invalidInput = true;
      }

      if (startValue > endValue || endValue > props.questionCount || startValue == endValue) {
        dashInvalidInput = true;
      }
    });

    let uniqueListValues = new Set(list);
    let isDistinct = list.length === uniqueListValues.size;

    if (questionIds.length > 0 && !/^(All|[0-9,-]+)$/i.test(questionIds)) {
      CustomToast('Only digits, ",", or "-" can be entered for questions attached to section. Please try again or cancel.', 'warning');
      return false;
    } else if (list.length > props.questionCount || list.some(value => parseInt(value) > props.questionCount) || list.some(value => parseInt(value) == 0) || dashInvalidInput) {
      CustomToast(`There are only ${props.questionCount} questions in this assignment. Please limit your entries to numbers between 1 and ${props.questionCount}.`, 'warning');
      return false;
    } else if (invalidInput || list.some(value => parseInt(value) < 0 || (value == '' && list != '')) || !isDistinct) {
      CustomToast('Incorrect input format. Please try again or cancel.', 'warning');
      return false;
    } else
      return true;
  };

  const handleSaveDocument = async (documentId, questionIdsValue) => {
    const isDisplayTextValidate = validateDisplayText();
    const isQuestionIdsValidate = validateQuestionIds();
    if (isDisplayTextValidate && isQuestionIdsValidate) {
      try {
        let options = { assignmentId: props.assignmentId, documentId: documentId, questionIds: questionIds, displayText: displayText };
        const result = await updateDocument(options);
        if (result.error) {
          console.log(result.error);
          CustomToast(result.error.data.error, 'error');
        }
        else {
          CustomToast('Resource Document Updated Successfully', 'success');
          setIsEditDocument(!isEditDocument);

          if (questionIdsValue != questionIds)
            props.fetchCastleResources(props.questionDetails?.questionId);
          else {
            let updatedAssignmentResource = assignmentResource.map(item =>
              item.resourceId == documentId ? { ...item, displayText: displayText, questionIds: questionIds == '' ? 'All' : questionIds } : item);
            setAssignmentResource(updatedAssignmentResource);
            let combinedResources = [...updatedAssignmentResource, ...questionResource];
            setCastleResources(combinedResources);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    setSelectedRow(null);
  };

  const handleDeleteDocument = async () => {
    try {
      let options = { assignmentId: props.assignmentId, documentId: documentId };
      const result = await removeDocument(options);
      if (result.error) {
        CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Resource Document Deleted Successfully', 'success');

        let updatedAssignmentResource = assignmentResource.filter(item => item.resourceId !== documentId);

        updatedAssignmentResource = updatedAssignmentResource.map(item => {
          if (item.position > deletedPosition) {
            return { ...item, position: item.position - 1 };
          }
          return item;
        });

        updatedAssignmentResource.sort((a, b) => a.position - b.position);
        setAssignmentResource(updatedAssignmentResource);
        let combinedResources = [...updatedAssignmentResource, ...questionResource];
        setCastleResources(combinedResources);
        setDeletedPosition(null);
        setSelectedRow(null);
      }
      setOpenConfirmModal(false);
    } catch (error) {
      console.log(error);
    }
  };

  const openFileInNewTab = (filePath) => {
    const width = 600;
    const height = 400;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    window.open(filePath, '_blank', `width=${width}, height=${height}, left=${left}, top=${top}`);
  };

  const updateDocumentPosition = async (resourceId, initialPosition, finalPosition) => {
    if (finalPosition > assignmentResource.length)
      finalPosition = assignmentResource.length;

    finalPosition = assignmentResource[finalPosition - 1].position;
    initialPosition = assignmentResource[initialPosition - 1].position;

    try {
      let options = { assignmentId: props.assignmentId, documentId: resourceId, newPosition: finalPosition };
      const result = await moveDocument(options);
      if (result.error) {
        CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Resource Moved Successfully', 'success');

        let updatedAssignmentResource = assignmentResource;
        if (initialPosition < finalPosition) {
          updatedAssignmentResource = updatedAssignmentResource.map(item => {
            if (item.position > initialPosition && item.position <= finalPosition) {
              return { ...item, position: item.position - 1 };
            }
            return item;
          });
        } else {
          updatedAssignmentResource = updatedAssignmentResource.map(item => {
            if (item.position >= finalPosition && item.position < initialPosition) {
              return { ...item, position: item.position + 1 };
            }
            return item;
          });
        }

        updatedAssignmentResource = updatedAssignmentResource.map(item => {
          if (item.position === initialPosition && item.resourceId === resourceId) {
            return { ...item, position: finalPosition };
          }
          return item;
        });

        updatedAssignmentResource.sort((a, b) => a.position - b.position);
        setAssignmentResource(updatedAssignmentResource);
        let combinedResources = [...updatedAssignmentResource, ...questionResource];
        setCastleResources(combinedResources);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(assignmentResource);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    if (result.source.index != result.destination.index) {
      updateDocumentPosition(parseInt(result.draggableId), result.source.index + 1, result.destination.index + 1);
      setAssignmentResource(items);
    }
  };

  const viewActionButton = (index, resource, resourceFromUrl, isLesson) => {
    return <>
      <OverlayTrigger
        key="viewToolTip"
        placement="top"
        overlay={<Tooltip className="custom-tooltip">View</Tooltip>}>
        <button
          id={'view' + index}
          className="no-print action-btn-tile yellow m-0 mt-2 z-index10"
          onClick={() => resourceFromUrl ? resourceViewHandlerFromUrl(resource) : isLesson ? resourceViewHandler('Lesson', props.assignmentDetails?.lessonId, lessonInfo.path) : resourceViewHandler(resource.resourceType, resource.resourceId, resource.resourceUrl)}
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      </OverlayTrigger>
    </>;
  };

  const getLesson = async (lessonId) => {
    if (lessonId) {
      let option = { setId: lessonId };
      let result = await getDocumentSetById(option).unwrap();
      setLessonInfo(result);
    }
  };

  const htmlContentHandler = async (path) => {
    const options = { filePath: path };
    const result = await getHtmlContent(options);
    if(result.error)
      setLessonText(result.error.data.error);
    else
    {
      setLessonText(result.data.content);
    }
  };

  React.useEffect(() => {
    getLesson(props.assignmentDetails?.lessonId);
  }, [props.assignmentDetails?.lessonId]);

  const handleDeleteAssignmentLesson = async () => {
    const option = {
      assignmentId: props.assignmentId,
      lessonId: 0
    };
    await updateAssignmentLesson(option).unwrap();
    let updatedAssignmentDetails = { ...props.assignmentDetails, lessonId: 0 };
    props.setAssignmentDetails(updatedAssignmentDetails);
    setLessonInfo([]);
    CustomToast('Lesson Deleted Successfully', 'success');
    setOpenLessonDeleteConfirmModal(false);
  };

  const checkLessons = async () => {
    const option = { courseId: props.assignmentDetails?.courseId };
    const response = await lessonExist(option).unwrap();
    setIsLessonAvailable(response);
  };

  const editDeleteDisabledActionButton = () => {
    return <div className='d-flex gap-2'>
      <button
        id={'edit'}
        className="action-btn-tile blue disabled m-0 mt-2">
        <FontAwesomeIcon icon={faEdit} />
      </button>
      <button
        id={'delete'}
        className="action-btn-tile red disabled m-0 mt-2">
        <FontAwesomeIcon icon={faTrashAlt} />
      </button>
    </div>;
  };

  return (
    <>
      <div className={`classroom-content-box mb-4 pb-4 ${castleResourceDetails && 'open'} `}>
        <div className="classroom-content-header d-flex justify-content-between align-items-center cursor-pointer" onClick={() => setCastleResourceDetails(!castleResourceDetails)}>
          <h4>Attached Resources</h4>
          {selectedRow}
          <button
            className="rounded-circle z-index10">
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
        <div className={`toggleDive ${!castleResourceDetails && 'd-none'}`}>
          <div className="custom-table table-responsive currentlist-table not-assigned-table mt-3">
            <table className="table currentlist-table position-relative" onMouseEnter={() => setIsMouseOver(false)} onMouseLeave={() => setIsMouseOver(true)}>
              <thead>
                <tr>
                  <th className='pr-unset no-print'>{' '}</th>
                  <th className='pr-unset'>Display Text</th>
                  <th className='pr-unset'>Resource Name</th>
                  <th className='pr-unset'>Resource Set</th>
                  <th className='pr-unset w-min-max-130'>Resource Type</th>
                  <th className='pr-unset'>
                    Question <br></br> Attached To{'  '}
                    {props.previewType != QuestionPreviewTypes.classRoomPreview && 
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip className="custom-tooltip">
                          To change the value click on the question id&apos;s then enter a
                          comma separated list, or ranges indicated by a dash (e.g.
                          &apos;1,2-5,9&apos;), of question numbers to apply document to or leave
                          blank to apply document to the whole assignment.
                        </Tooltip>
                      }>
                      <FontAwesomeIcon
                        markerStart="5"
                        icon={faCircleQuestion}
                        color="#88CBF1"
                      />
                    </OverlayTrigger>
                    }
                  </th>
                  <th className='no-print'>{'   '}</th>
                </tr>
              </thead>
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId='rows'>
                  {(provided) => (
                    <tbody {...provided.droppableProps} ref={provided.innerRef}>
                      {isLoading ?
                        <>
                          {Array.from({ length: 3 }).map((_, index) => (
                            <tr key={`row${index}`}>
                              {[...Array(7)].map((_, index) => (
                                <td key={`th${index}`}><Skeleton /></td>
                              ))}
                            </tr>
                          ))}
                        </>
                        :
                        castleResources.length > 0 || (props.questionDetails?.question?.externalFiles?.length > 0 && props.questionDetails?.question?.externalFiles?.some((resource) => !resource.filePath?.endsWith('.htm') && !resource.filePath?.endsWith('.html'))) || Object.keys(lessonInfo).length > 0 ?
                          <>
                            {castleResources?.map((resource, index) => (
                              <>
                                <Draggable key={resource.resourceId} draggableId={`${resource.resourceId}`} index={index} isDragDisabled={props.previewType !== QuestionPreviewTypes.editAssignmentPreview || isEditDocument || !resource.isAssignmentDocument}>
                                  {(provided, snapshot) => (
                                    <tr key={'castleRes' + index} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                      className={`${resource.questionIds != null && 'fw-semibold'} ${snapshot.isDragging && 'drag-style'} ${(isMouseOver && snapshot.isDragging) && ' cursor-not-allowed'}`}>
                                      <td className='no-print'>
                                        {!isEditDocument && resource.isAssignmentDocument && props.previewType === QuestionPreviewTypes.editAssignmentPreview ?
                                          <OverlayTrigger
                                            key="viewToolTip"
                                            placement="top"
                                            overlay={<Tooltip className="custom-tooltip">Grab to Drag</Tooltip>}>
                                            <div
                                              id={'view' + index}
                                              className="align-items-center border-0 btn cursor-grab d-flex">
                                              <FontAwesomeIcon icon={faBars} />
                                            </div>
                                          </OverlayTrigger>
                                          : ' '}
                                      </td>
                                      {props.previewType == QuestionPreviewTypes.editAssignmentPreview ?
                                        (<>
                                          {isEditDocument == true && selectedRow == index ?
                                            (
                                              <td>
                                                <input
                                                  id="inputDisplayText"
                                                  autoComplete="off"
                                                  className={`form-control ${displayText.length > 100 && 'border-danger'}`}
                                                  value={displayText}
                                                  onChange={(e) => setDisplayText(e.target.value)}
                                                />
                                                {displayText.length > 100 &&
                                                  <div className="text-danger">The Display Text has exceeded a limit of 100 characters!</div>
                                                }
                                              </td>
                                            ) : (
                                              <td className='text-truncate w-min-max-130'>{resource.displayText}</td>
                                            )
                                          }
                                        </>) :
                                        <td className='text-truncate w-min-max-130'>{resource.displayText}</td>
                                      }
                                      <td className='text-truncate w-min-max-130'>{resource.resourceName}</td>
                                      <td className='text-truncate w-min-max-130'>{resource.resourceSet}</td>
                                      <td>
                                        {resource.questionIds == null ?
                                          <OverlayTrigger
                                            key="teacherDocumentsTooltip"
                                            placement="top"
                                            overlay={<Tooltip className="custom-tooltip">This is a Teacher resource and cannot be moved, edited, or deleted.</Tooltip>}>
                                            <span><img src={castleLogo} className="img-fluid h-75 mx-1" alt="Castle Logo" />{resource.resourceType}</span>
                                          </OverlayTrigger>
                                          : resource.resourceType
                                        }
                                      </td>
                                      {props.previewType == QuestionPreviewTypes.editAssignmentPreview ?
                                        (<>
                                          {isEditDocument == true && selectedRow == index ?
                                            (
                                              <td>
                                                <input
                                                  id="inputQuestionIds"
                                                  autoComplete="off"
                                                  className="form-control"
                                                  value={questionIds}
                                                  onChange={(e) => setQuestionIds(e.target.value)}
                                                />
                                              </td>
                                            ) : (
                                              <td>{resource.questionIds == null ? '-' : resource.questionIds}</td>
                                            )
                                          }
                                        </>) :
                                        <td>{resource.questionIds == null ? '-' : resource.questionIds}</td>
                                      }
                                      {!snapshot.isDragging &&
                                        <>
                                          {props.previewType == QuestionPreviewTypes.editAssignmentPreview && resource.isAssignmentDocument ?
                                            (<>
                                              <td className="no-print align-items-center gap-2 border-bottom-0 justify-content-end d-flex">
                                                {selectedRow != index && viewActionButton(index, resource, false, false)}
                                                <div className="d-flex align-items-center gap-2 justify-content-end">
                                                  {isEditDocument == true && selectedRow == index ?
                                                    <>
                                                      <OverlayTrigger
                                                        key="saveToolTip"
                                                        placement="top"
                                                        overlay={<Tooltip className="custom-tooltip">Save</Tooltip>}>
                                                        <button
                                                          id={'save' + index}
                                                          className={`action-btn-tile green m-0 mt-2 ${displayText.length > 100 && 'disabled'}`}
                                                          onClick={() => {
                                                            setSelectedRow(index);
                                                            handleSaveDocument(resource.resourceId, resource.questionIds);
                                                          }}>
                                                          <FontAwesomeIcon icon={faSave} />
                                                        </button>
                                                      </OverlayTrigger>
                                                      <OverlayTrigger
                                                        key="cancelToolTip"
                                                        placement="top"
                                                        overlay={<Tooltip className="custom-tooltip">Cancel</Tooltip>}>
                                                        <button
                                                          id={'cancel' + index}
                                                          className="action-btn-tile red m-0 mt-2"
                                                          onClick={() => {
                                                            setSelectedRow(null);
                                                            setIsEditDocument(!isEditDocument);
                                                            setDisplayText(resource.displayText);
                                                          }}>
                                                          <FontAwesomeIcon icon={faXmark} />
                                                        </button>
                                                      </OverlayTrigger>
                                                    </>
                                                    :
                                                    <OverlayTrigger
                                                      key="editToolTip"
                                                      placement="top"
                                                      overlay={<Tooltip className="custom-tooltip">Edit</Tooltip>}>
                                                      <button
                                                        id={'edit' + index}
                                                        className="action-btn-tile blue m-0 mt-2"
                                                        onClick={() => {
                                                          setSelectedRow(index);
                                                          setDisplayText(resource.displayText);
                                                          setQuestionIds(resource.questionIds);
                                                          setIsEditDocument(!isEditDocument);
                                                        }}
                                                      >
                                                        <FontAwesomeIcon icon={faEdit} />
                                                      </button>
                                                    </OverlayTrigger>
                                                  }
                                                  {selectedRow != index &&
                                                    <OverlayTrigger
                                                      key="deleteToolTip"
                                                      placement="top"
                                                      overlay={<Tooltip className="custom-tooltip">Delete</Tooltip>}>
                                                      <button
                                                        id={'delete' + index}
                                                        className="action-btn-tile red m-0 mt-2"
                                                        onClick={() => {
                                                          setOpenConfirmModal(true);
                                                          setDisplayText(resource.displayText);
                                                          setDocumentId(resource.resourceId);
                                                          setDeletedPosition(resource.position);
                                                        }}
                                                      >
                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                      </button>
                                                    </OverlayTrigger>
                                                  }
                                                </div>
                                              </td>
                                            </>)
                                            : (
                                              <td className='no-print align-items-center d-flex border-bottom-0 gap-2 justify-content-end'>
                                                {viewActionButton(index, resource, false, false)}
                                                {props.previewType == QuestionPreviewTypes.editAssignmentPreview && editDeleteDisabledActionButton()}
                                              </td>
                                            )}
                                        </>
                                      }
                                    </tr>
                                  )}
                                </Draggable>
                              </>
                            ))}
                            {provided.placeholder}
                            {props.questionDetails?.question?.externalFiles
                              ?.filter((resource) => !resource.filePath?.endsWith('.htm') && !resource.filePath?.endsWith('.html'))
                              .map((resource, index) => (
                                <tr key={'Res' + index}>
                                  <td className='no-print'>{' '}</td>
                                  <td>{'-'}</td>
                                  <td>{'-'}</td>
                                  <td>{'-'}</td>
                                  <td>
                                    <OverlayTrigger
                                      key="castleResourceTooltip"
                                      placement="top"
                                      overlay={<Tooltip className="custom-tooltip">This is a Castle assigned resource and cannot be moved, edited, or deleted.</Tooltip>}>
                                      <span>
                                        <img src={castleLogo} className="img-fluid h-75 mx-1" />
                                        {resource.filePath?.endsWith('.mp3')
                                          ? 'Audio'
                                          : resource.filePath?.endsWith('.mp4')
                                            ? 'Video'
                                            : resource.filePath?.endsWith('.gif') ||
                                              resource.filePath?.endsWith('.jpg') ||
                                              resource.filePath?.endsWith('.png') ||
                                              resource.filePath?.endsWith('.bmp')
                                              ? 'Image'
                                              : 'Other'}
                                      </span>
                                    </OverlayTrigger>
                                  </td>
                                  <td>{'-'}</td>
                                  <td className='no-print align-items-center d-flex border-bottom-0 gap-2 justify-content-end'>
                                    {viewActionButton(index, resource.filePath, true, false)}
                                    {props.previewType == QuestionPreviewTypes.editAssignmentPreview && editDeleteDisabledActionButton()}
                                  </td>
                                </tr>
                              ))}
                            {props.assignmentDetails?.lessonId != 0 && Object.keys(lessonInfo).length > 0 &&
                              <tr key={'Less0'}>
                                <td className='no-print'>{' '}</td>
                                <td className='text-truncate w-min-max-130'>{lessonInfo?.description}</td>
                                <td className='text-truncate w-min-max-130'>{(lessonInfo?.label.length > 0 ? lessonInfo?.label + ' : ' : lessonInfo?.label) + lessonInfo?.description}</td>
                                <td>{'-'}</td>
                                <td>
                                  <OverlayTrigger
                                    key="castleLessonTooltip"
                                    placement="top"
                                    overlay={<Tooltip className='custom-tooltip'>This is a resource type lesson and cannot be moved or edited.</Tooltip>}>
                                    <span><img src={castleLogo} className="img-fluid h-75 mx-1" />Lesson</span>
                                  </OverlayTrigger>
                                </td>
                                <td>{'-'}</td>
                                <td className='no-print align-items-center d-flex border-bottom-0 gap-2 justify-content-end'>
                                  {viewActionButton(0, [], false, true)}
                                  {props.previewType == QuestionPreviewTypes.editAssignmentPreview &&
                                    <div className='d-flex gap-2'>
                                      <button
                                        id={'edit'}
                                        className="action-btn-tile blue disabled m-0 mt-2">
                                        <FontAwesomeIcon icon={faEdit} />
                                      </button>
                                      <OverlayTrigger
                                        key="deleteToolTip"
                                        placement="top"
                                        overlay={<Tooltip className="custom-tooltip">Delete</Tooltip>}>
                                        <button
                                          id={'delete'}
                                          className="action-btn-tile red m-0 mt-2"
                                          onClick={async () => { setDisplayText(lessonInfo?.description); setOpenLessonDeleteConfirmModal(true); }}>
                                          <FontAwesomeIcon icon={faTrashAlt} />
                                        </button>
                                      </OverlayTrigger>
                                    </div>
                                  }
                                </td>
                              </tr>
                            }
                          </>
                          :
                          <>
                            <tr>
                              <td colSpan={7} className='text-center'>
                                <p className='text-danger'>No Attached Resources</p>
                              </td>
                            </tr>
                          </>
                      }
                    </tbody>
                  )}
                </Droppable>
              </DragDropContext>
            </table>
            {props.previewType == QuestionPreviewTypes.editAssignmentPreview &&
              <div className={`d-flex pt-4 pb-4 align-items-center ${props.questionDetails?.referencePath?.length > 0 ? ' justify-content-between' : ' justify-content-end'}`}>
                {props.questionDetails?.referencePath?.length > 0 && (
                  <div
                    onClick={() => openFileInNewTab(props.questionDetails?.referencePath)}
                    className='align-items-center d-flex gap-1 text-orange cursor-pointer'>
                    <FontAwesomeIcon icon={faTable} />
                    Reference Tables
                  </div>
                )}
                <div className='d-flex gap-2'>
                  <OverlayTrigger
                    key={'attached-resource-info'}
                    placement="left"
                    overlay={
                      <Tooltip className="initial-assignment-tooltip">
                        <b>Attached Resources </b>
                        are resources supplying supplementary information to the student related to the assignment.
                        These can be reading selections, lessons, reference tables, directions, mp3 audio files, mp4 video files,
                        or anything else the student needs in order to complete the assignment. These resources are created or uploaded using the Personal Content Set feature.
                        The PCS editor allows the teacher to type in the contents of the documents, upload a file or a URL can be entered if the information is on another web server.
                        <br /><br />
                        The <b>label</b> is the text of the link that the student sees when they are working on the assignment.
                        <br /><br />
                        If there is more than one resource, use the UP and DOWN arrows to position the documents as they will appear to the students in the order that you see them here.
                      </Tooltip>
                    }>
                    <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
                  </OverlayTrigger>
                  <button
                    onClick={async () => { await checkLessons(); setOpenAttachResource(true); }}
                    className="btn btn-castleWhite">
                    Attach Resource
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <VideoModal videoUrl={videoUrl} isOpen={videoModal} onClose={() => setVideoModal(false)} />
      <DocumentModal value={documentText} isOpen={documentModal} onClose={() => setDocumentModal(false)} />
      <AudioModal audioUrl={audioUrl} isOpen={audioModal} onClose={() => setAudioModal(false)} />
      <ImageModal imageUrl={imageUrl} isOpen={imageModal} onClose={() => setImageModal(false)} />
      <LessonModal description={lessonInfo.description} value={lessonText} isOpen={openLessonModal} onClose={() => setOpenLessonModal(false)} />
      <ConfirmationModal
        isOpen={openConfirmModal}
        onClose={() => { setOpenConfirmModal(false); setSelectedRow(null); }}
        onSave={handleDeleteDocument}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          `Are you sure that you want to remove the resource document named "${displayText}" ?`
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <ConfirmationModal
        isOpen={openLessonDeleteConfirmModal}
        onClose={() => { setOpenLessonDeleteConfirmModal(false); setSelectedRow(null); }}
        onSave={handleDeleteAssignmentLesson}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          `Are you sure that you want to remove the resource document named "${displayText}" ?`
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <AddNewResource
        openAttachResource={openAttachResource}
        setOpenAttachResource={setOpenAttachResource}
        assignmentName={props.assignmentName}
        assignmentId={props.assignmentId}
        displayText={displayText}
        setDisplayText={setDisplayText}
        validateDisplayText={validateDisplayText}
        castleResourceDetailsHandler={props.fetchCastleResources}
        questionDetails={props.questionDetails}
        setLessonInfo={setLessonInfo}
        setAssignmentDetails={props.setAssignmentDetails}
        assignmentDetails={props.assignmentDetails}
        isLessonAvailable={isLessonAvailable}
      ></AddNewResource>
    </>
  );
};

AttachResources.propTypes = {
  questionDetails: PropTypes.object,
  nextQuestionHandler: PropTypes.func,
  assignedStatus: PropTypes.number,
  assignmentId: PropTypes.number,
  questionCount: PropTypes.number,
  previewType: PropTypes.string,
  assignmentName: PropTypes.string,
  setAssignmentDetails: PropTypes.func,
  assignmentDetails: PropTypes.object,
  prefetchedData: PropTypes.array,
  fetchCastleResources: PropTypes.func,
  onLoadComplete: PropTypes.func
};

export default AttachResources;
